import { PropsWithChildren, createContext } from "react";

const LOCALHOST_API_KEY = "AIzaSyC7d2dEkj0JyVxA3W4ffv2qQ9a4OrG5Xzo";

/**
 * Shares a Google Maps API key throughout the app.
 * If no key is provided, the default is a localhost key that can only be used with localhost.
 */
export const GoogleMapsAPIKeyContext = createContext(
  "AIzaSyC7d2dEkj0JyVxA3W4ffv2qQ9a4OrG5Xzo"
);

interface Props extends PropsWithChildren {
  apiKey?: string;
}

export function GoogleMapsAPIKeyProvider(props: Props) {
  const { apiKey = LOCALHOST_API_KEY } = props;

  return (
    <GoogleMapsAPIKeyContext.Provider value={apiKey}>
      {props.children}
    </GoogleMapsAPIKeyContext.Provider>
  );
}
